import React, { useState, useEffect } from 'react'
import Slider from 'react-slick'
import { Typography, Button, Grid, useMediaQuery, Box } from '@mui/material'
import '../../Styles/NoticeCarosel.css'
import { fetchData } from '../../Assets/API/apiservices'
import {
  IMAGE_BASE_PATH_DBRALC,
  IMAGE_BASE_PATH_COMMON,
  ORGANIZATION_ID,
  SUB_ORGANIZATION_ID,
} from '../../Config/Config'

const NoticeCarousel = ({ data }) => {
  const [noticeData, setNoticeData] = useState([])
  const [expandedIndex, setExpandedIndex] = useState(null)

  // Use Material-UI's useMediaQuery for responsiveness
  const isSmallScreen = useMediaQuery('(max-width:600px)')

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    afterChange: (currentSlide) => {
      setExpandedIndex(null)
    },
  }

  useEffect(() => {
    const getActivities = async () => {
      try {
        const response = await fetchData(
          `notices?organization_id=${ORGANIZATION_ID}&sub_organization_id=${SUB_ORGANIZATION_ID}`
        )
        setNoticeData(response.rows)
      } catch (error) {
        console.error('Error fetching activities:', error)
      }
    }
    getActivities() // Fetch data once when the app loads
  }, [])

  const handleToggleText = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index) // Toggle between expanded and collapsed
  }

  return (
    <Box
      className="carousel-container py-4"
      sx={{ maxWidth: 1200, margin: '0 auto' }}
    >
      <Typography
        variant="h6"
        className="m-0 carousel-title py-1"
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          color: 'primary.main',
        }}
      >
        Notice Board
      </Typography>
      <Slider className="px-3" {...settings}>
        {noticeData.map((item, index) => (
          <Box key={index} sx={{ px: isSmallScreen ? 1 : 4 }}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
              className="carousel-item"
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    minHeight: 100,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    variant="body1"
                    color="white"
                    sx={{ textAlign: 'center' }}
                  >
                    {expandedIndex === index ? (
                      <>
                        {item.description}
                        <Button
                          onClick={() => handleToggleText(index)}
                          color="primary"
                          size="small"
                          sx={{
                            display: 'block',
                            mx: 'auto',
                            mt: 1,
                            textTransform: 'none',
                          }}
                        >
                          Read Less
                        </Button>
                      </>
                    ) : (
                      <>
                        {item.description.length > 100 ? (
                          <>
                            {item.description.substring(0, 100) + '... '}
                            <Button
                              onClick={() => handleToggleText(index)}
                              color="primary"
                              size="small"
                              sx={{
                                display: 'inline',
                                textTransform: 'none',
                                p: 0,
                                ml: 0.5,
                              }}
                            >
                              Read More
                            </Button>
                          </>
                        ) : (
                          item.description
                        )}
                      </>
                    )}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={10} lg={8}>
                <Box
                  sx={{
                    height: isSmallScreen ? 200 : 350,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                    p: 1,
                  }}
                >
                  <img
                    src={IMAGE_BASE_PATH_DBRALC + item.image_url || ''}
                    alt="Notice"
                    loading="lazy"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      maxWidth: '100%',
                      maxHeight: '100%',
                    }}
                    onError={(e) => {
                      e.target.src =
                        IMAGE_BASE_PATH_COMMON +
                        'Placeholders/Placeholder_Image.jpg'
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        ))}
      </Slider>
    </Box>
  )
}

export default NoticeCarousel
